<template>
  <div class='SelectLogo'>
    <div class="label" @click="$refs.arrow.run()">
      <div class="text-label">
        Logomarca
        <div class="sub-label">280px X 100px</div>
      </div>
      <div class="arrow" @click.stop>
        <arrow-icon ref="arrow" @showSubLinks="newValue => sublink = newValue"/>
      </div>
    </div>
    <div class="cont-select" :class="{ contselect: sublink }">
      <div class="cont-s">
        <div class="cont-logo">
          <input ref="in" v-show="false" type="file" @change="inFile"/>
          <img v-if="Logo" :src="Logo" class="logo-preview"/>
          <button @click="$refs.in.click()">Selecione a logomarca</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ArrowIcon from '../Icons/ArrowIcon'
export default {
  name: 'SelectLogo',
  components: { ArrowIcon },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Logo'])
  },
  methods: {
    ...mapActions(['UpdateLogo']),
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.UpdateLogo(reader.result)
        // console.log(reader.result)
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  }
}
</script>

<style scoped>
.SelectLogo {
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.label {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 16px;
  color: #648EEA;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
}

.text-label {
  width: 90%;
}

.cont-select {
  max-height: 0px;
  border-radius: 5px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.contselect {
  border-radius: 5px;
  max-height: 600px;
  transition: max-height 0.4s ease-in;
}

.cont-s {
  padding: 3%;
  margin-top: 1%;
}

.text-label {
  padding: 2%;
}

.sub-label {
  font-size: 12px;
  color: #888888;
  margin-top: 2px;
}

.cont-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-preview {
  height: 32px;
  max-width: 120px;
  object-fit: contain;
  border: thin solid #CCCCCC;
  border-radius: 3px;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  padding: 1.5%;
  border-radius: 5px;
  cursor: pointer;
}
</style>
